import { AppState } from "../../reducers";
import { OfficesState } from "./reducer";

export const officesSelector = (state: AppState): OfficesState => {
  return state.offices;
};
